'use strict';

const mmWidgets = require('./mm-widgets');
require('./dispatched-event-toggle-widget');

mmWidgets.fn.accountInfoValueToggleWidget = function (subscriptionModel, authenticationModel) {
	const eventValueDataKey = 'data-mm-account-info-toggle',
		valueAttrName = 'data-mm-account-info-value',
		toggleClassDataAttrName = 'data-mm-account-info-toggle-class';

	return mmWidgets(this).dispatchedEventToggleWidget(subscriptionModel, ['load-subscription-failed', 'goldAccountInfo'], eventValueDataKey, valueAttrName, toggleClassDataAttrName)
				.dispatchedEventToggleWidget(authenticationModel, ['not-authenticated'], false, valueAttrName, toggleClassDataAttrName);

};
